/** Calculates the scale factor of a "contained" rectangle, so it FITS perfectly inside a "container" rectangle without
 * distorting the aspect ratio of the contained rectangle.
 * **/

type ScaleFunctionParams = {
  containerWidth: number;
  containerHeight: number;
  containedWidth: number;
  containedHeight: number;
};

export function calculateFitScaleFactor({
  containerWidth,
  containerHeight,
  containedWidth,
  containedHeight,
}: ScaleFunctionParams): number {
  const widthScale: number = containerWidth / containedWidth;
  const heightScale: number = containerHeight / containedHeight;

  return Math.min(widthScale, heightScale);
}

/** Calculates the scale factor of a "contained" rectangle, so it FILLS a "container" rectangle without
 * distorting the aspect ratio of the contained rectangle.
 * **/

export function calculateFillScaleFactor({
  containerWidth,
  containerHeight,
  containedWidth,
  containedHeight,
}: ScaleFunctionParams): number {
  const widthScale: number = containerWidth / containedWidth;
  const heightScale: number = containerHeight / containedHeight;

  return Math.max(widthScale, heightScale);
}
